'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Represents optional values: a value is either a certain value or nothing.
 * */
var Maybe = function () {
  _createClass(Maybe, null, [{
    key: 'of',
    value: function of(value) {
      return new Maybe(value);
    }
  }]);

  function Maybe(value) {
    _classCallCheck(this, Maybe);

    this.value = value;
  }

  /**
   * Return itself if the value is nothing, otherwise will return the value return by mapper.
    * */


  _createClass(Maybe, [{
    key: 'map',
    value: function map(opt) {
      return this.isNothing() ? this : new Maybe(opt(this.value));
    }
  }, {
    key: 'isNothing',
    value: function isNothing() {
      return this.value === null || this.value === undefined;
    }
  }]);

  return Maybe;
}();

exports.default = Maybe;